import {Component, Input, OnInit} from '@angular/core';
import {IntegrationModule} from "../../../../model/integration-module";
import {Template} from "../../../../model/template";
import {DevicesService} from "../../../../services/devices.service";

@Component({
  selector: 'app-template-integration-modules',
  templateUrl: './template-integration-modules.component.html',
  styleUrls: ['./template-integration-modules.component.scss']
})
export class TemplateIntegrationModulesComponent implements OnInit {

  @Input()
  public template: Template;

  public integrationModules: IntegrationModule[];
  public totalModules: number;
  public loadingModules: boolean;

  public rows = 10;
  public first = 0;

  constructor(private devicesService: DevicesService) {
    this.integrationModules = [];
  }

  ngOnInit(): void {
    this.loadIntegrationModules();
  }

  loadIntegrationModules() {
    this.loadingModules = true;
    this.integrationModules = new Array(this.rows);
    if (this.template.type === 'DEVICE') {
      this.integrationModules = this.template.content?.integrationModules ? this.template.content.integrationModules : [];
      let dataKey = 0;
      this.integrationModules.forEach(module => {
        if (module.additionalInfo) {
          try {
            module.additionalInfo = JSON.parse(module.additionalInfo);
          } catch (e) {
            module.additionalInfo = null;
          }
        }
        if (module.technicalDetails) {
          try {
            module.technicalDetails = JSON.parse(module.technicalDetails);
          } catch (e) {
            module.technicalDetails = null;
          }
        }
        module['dataKey'] = dataKey++;
      });
    } else {
      this.integrationModules = [];
    }
    this.totalModules = this.integrationModules.length;
    this.loadingModules = false;
  }

}
